import React from 'react';
import { View, FlatList } from 'react-native';
import {connect} from 'react-redux';
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import {getPosts} from '../../redux/actions'

import PostComponent from './PostComponent';
import {CardTextArrow, ConfirmationDialogue, SpinnerControl, SpinnerDialogue} from "../../components";
import deleteMethod from "../../api/methods/delete";
import {MURAL_DELETE} from "./api/muralEndpoints";

class MuralListRender extends React.Component {

    state = {
        showDeleteConfirmation: false,
        postIdToDelete: null,
        showDeleteProgress: false,
        deleteOperationComplete: false,
        isDeleting: false,

        fetchDate: null,
    }

    componentDidMount = async () => {
        await this.props.getPosts(this.props.authToken);
        this.setState({ fetchDate: new Date().toISOString(), })
    }

    showDeleteConfirmation = (postId) => {
        this.setState({ showDeleteConfirmation: true, postIdToDelete: postId });
    }

    handleDelete = async () => {
        if (this.state.isDeleting) return;
        this.setState({
            isDeleting: true,
            deleteOperationComplete: false,
            showDeleteProgress: true,
            showDeleteConfirmation: false,
        })

        try {

            const endpoint = MURAL_DELETE(this.state.postIdToDelete);
            await deleteMethod(endpoint);
            this.props.getPosts();
            this.setState({ deleteOperationComplete: true, postIdToDelete: null });

        } catch (e) {
            console.log(e);
        }

        this.setState({ isDeleting: false });
    }

    render() {
        return (
            <View style={{ width: 600 }}>

                <ConfirmationDialogue
                    isModalVisible={this.state.showDeleteConfirmation}
                    onClose={() => this.setState({ showDeleteConfirmation: false })}
                    onConfirm={this.handleDelete}
                    descriptionText={"Você tem certeza que deseja deletar este post do mural?"}
                    titleText={"Deletar Post"}
                />

                <SpinnerDialogue
                    isModalVisible={this.state.showDeleteProgress}
                    onClose={() => this.setState({ deleteOperationComplete: false, showDeleteProgress: false, })}
                    isFinished={this.state.deleteOperationComplete}
                />

                {
                    this.props.isFetching === false &&
                        <CardTextArrow
                            text={"Novo post"}
                            showArrow={true}
                            onPress={() => this.props.history.push('/mural/post')}
                        />
                }

                <SpinnerControl isFetching={this.props.isFetching} text={"Carregando mural"} />

                <FlatList
                    contentContainerStyle={{ marginTop: 32 }}
                    data={this.props.posts}
                    renderItem={({item}) => {
                        return <PostComponent
                            {...item}
                            postData={item}
                            postId={item.SK}
                            answerToId={null}
                            userId={item.creatorId}
                            currentUserId={this.props.userId}
                            authToken={this.props.authToken}
                            renderComment={true}
                            handleDelete={this.showDeleteConfirmation}
                        />
                    }}
                    keyExtractor={(item) => item.SK.toString()}
                />
            </View>
        )
    }
}

const mapStateToProps = state => {
    return {
        isFetching: state.post.isFetching,
        posts: state.post.posts,
        error: state.post.updateError,
        userId: state.user.userId,
    }
};

export default compose(
    withRouter,
    connect(mapStateToProps, { getPosts })
)
(MuralListRender);
